import { useCallback, useRef } from 'react'

const usePreventDoubleEvent = (eventHandler: (...arg) => any, delay = 1000) => {
  const prevent = useRef(false)
  const timer = useCallback(() => {
    prevent.current = true
    setTimeout(() => void (prevent.current = false), delay)
  }, [delay])

  const onEventHandle = useCallback(
    (...arg) => {
      if (prevent.current) {
        return
      }
      timer()
      eventHandler(...arg)
    },
    [eventHandler, timer]
  )

  return [onEventHandle]
}

export default usePreventDoubleEvent
